import { TabsList } from '@mui/base'
import { styled } from '@mui/material'
import useGetTabListTemplate from '~/src/components/mui-wrappers/styled/ordering-methods/tab-list/styles/useGetTabListTemplate'

const OrderingMethodTabList = styled(TabsList)(() => useGetTabListTemplate().getComponentSx())

export default OrderingMethodTabList
